module.exports = __webpack_public_path__ + "static/media/peghook-H1.423c8960.png";